import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    components: {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    width: "0.8em",
                    height: "0.8em",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.MuiButton-text": {
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: 800,
                        fontFamily: "quasimoda, sans-serif",
                        "&:hover": {
                            backgroundColor: "transparent",
                            color: "#ff5c00",
                        },
                    },
                    "&.MuiButton-outlined": {
                        border: 0,
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "10px 25px",
                        color: "#0c1028",
                        fontSize: "13px",
                        fontWeight: 700,
                        fontFamily: "quasimoda, sans-serif",
                        "&:hover": {
                            backgroundColor: "#ff8a00",
                            color: "#fff",
                        },
                    },
                    "&.MuiButton-outlined.variant-1": {
                        backgroundColor: "#ff5c00",
                        color: "#fff",
                        fontFamily: "quasimoda, sans-serif",
                        "&:hover": {
                            backgroundColor: " #ff8a00",
                        },
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "&.open .MuiOutlinedInput-root": {
                        paddingBottom: "25px",
                    },
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "20px 20px",
                        border: "1px solid #fff",
                        outline: "none",
                        boxShadow: "none",
                        color: "#fff",
                        backgroundColor: "transparent",
                        "&:hover fieldset": {
                            border: "none",
                        },
                        "&:focus-within fieldset": {
                            border: "none",
                        },
                        "& fieldset": {
                            border: "none",
                        },
                        "& input": {
                            color: "#fff", // White text color
                        },
                        "& .MuiSvgIcon-root": {
                            color: "#fff", // White icon color
                        },
                    },
                },
            },
        },
    },
});
